import { render } from "./WLGHZX.vue?vue&type=template&id=44e2a027"
import script from "./WLGHZX.vue?vue&type=script&lang=js"
export * from "./WLGHZX.vue?vue&type=script&lang=js"

import "./WLGHZX.vue?vue&type=style&index=0&id=44e2a027&lang=scss"

import exportComponent from "D:\\大众物流官网\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__